import {createContext, useContext} from 'react';

export const TrackingContext = createContext({});
export const TrackingContextOverride = TrackingContext.Provider;

export function TrackingContextAppend({children, value}) {
    const parentContext = useContext(TrackingContext);
    if (!value) return children;
    return <TrackingContext.Provider value={{...parentContext, ...value}}>{children}</TrackingContext.Provider>;
}
